<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px;">

  <!-- Search -->
  <div style="position: relative; margin-bottom: 16px;">
    <mat-icon style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">search</mat-icon>
    <input type="text" [(ngModel)]="searchTxt" (keyup)="buscar($event)" placeholder="Buscar beneficiario"
      style="width: 100%; padding: 12px 16px 12px 42px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 0.9rem; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
      onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
  </div>

  <!-- Add beneficiary -->
  <button type="button" (click)="openCreateDialog()"
    style="width: 100%; padding: 12px; border: 2px dashed #1C593D; background: white; color: #1C593D; border-radius: 12px; font-size: 0.85rem; font-weight: 600; cursor: pointer; margin-bottom: 20px; transition: all 0.2s;"
    onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle; margin-right: 4px; color: #1C593D;">add</mat-icon>
    Agregar Beneficiario
  </button>

  <!--
    Redes pausadas: el cliente ve todos sus beneficiarios, pero solo puede
    elegir los de redes activas. La franja dice cuáles son, para que un
    beneficiario gris no parezca un error.
  -->
  <div *ngIf="avisoRedes" role="status"
    style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; flex-shrink: 0; color: #b45309;">pause_circle</mat-icon>
    <span style="font-size: 0.78rem; font-weight: 500; color: #92400e; line-height: 1.45;">{{ avisoRedes }}</span>
  </div>

  <!-- Beneficiary list -->
  <div style="margin-bottom: 16px;">
    <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 12px;">Tus beneficiarios</h3>
    <div *ngIf="listaBeneficiariosFiltrados && listaBeneficiariosFiltrados.length > 0"
      style="display: flex; flex-direction: column; gap: 10px; max-height: 300px; overflow-y: auto;">
      <div *ngFor="let beneficiario of listaBeneficiariosFiltrados"
        (click)="elegir(beneficiario)"
        [attr.aria-disabled]="pausado(beneficiario)"
        style="display: flex; align-items: center; gap: 12px; padding: 14px; border: 2px solid; border-radius: 12px; cursor: pointer; transition: all 0.2s;"
        [style.cursor]="pausado(beneficiario) ? 'not-allowed' : 'pointer'"
        [style.opacity]="pausado(beneficiario) ? '0.6' : '1'"
        [style.borderColor]="beneficiarioEscogido === beneficiario ? '#1C593D' : '#e5e7eb'"
        [style.background]="beneficiarioEscogido === beneficiario ? '#f0fdf4' : (pausado(beneficiario) ? '#f9fafb' : 'white')">
        <!-- Avatar -->
        <div style="width: 42px; height: 42px; border-radius: 50%; background: linear-gradient(135deg, #1C593D, #34d399); display: flex; align-items: center; justify-content: center; color: white; font-size: 1rem; font-weight: 700; flex-shrink: 0;">
          {{ beneficiario.beneficiario_nombre.charAt(0) }}
        </div>
        <div style="flex: 1; min-width: 0;">
          <span style="display: block; font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">
            {{ beneficiario.beneficiario_nombre }} {{ beneficiario.beneficiario_apellido }}
          </span>
          <span style="display: block; font-size: 0.75rem; color: #6b7280; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{ beneficiario.medioCriptomoneda_descripcion }}: {{ beneficiario.beneficiario_medio_recepcion }}
          </span>
          <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px;">
            <span style="padding: 1px 8px; border-radius: 10px; font-size: 0.66rem; font-weight: 700; background: #f3f4f6; color: #374151;">
              {{ etiquetaRed(beneficiario) }}
            </span>
            <span *ngIf="pausado(beneficiario)"
              style="padding: 1px 8px; border-radius: 10px; font-size: 0.66rem; font-weight: 700; background: #fef3c7; color: #92400e; border: 1px solid #fde68a;">
              Red pausada
            </span>
          </div>
        </div>
        <!-- Radio visual -->
        <div *ngIf="!pausado(beneficiario)"
          style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid; flex-shrink: 0; display: flex; align-items: center; justify-content: center;"
          [style.borderColor]="beneficiarioEscogido === beneficiario ? '#1C593D' : '#d1d5db'"
          [style.background]="beneficiarioEscogido === beneficiario ? '#1C593D' : 'white'">
          <div *ngIf="beneficiarioEscogido === beneficiario"
            style="width: 8px; height: 8px; background: white; border-radius: 50%;"></div>
        </div>
        <mat-icon *ngIf="pausado(beneficiario)" title="Red pausada"
          style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0; color: #9ca3af;">block</mat-icon>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!listaBeneficiariosFiltrados || listaBeneficiariosFiltrados.length === 0"
      style="text-align: center; padding: 30px 16px; border: 2px dashed #e5e7eb; border-radius: 12px;">
      <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #d1d5db; margin-bottom: 8px;">people</mat-icon>
      <p style="font-size: 0.9rem; font-weight: 600; color: #1e5a3f; margin: 0 0 4px;">No tienes beneficiarios registrados</p>
      <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">Agrega uno para continuar</p>
    </div>
  </div>


</div>

<!-- Action buttons (fuera de la card para sticky móvil) -->
<div class="step-actions">
  <button type="button" (click)="emitChangeStep()"
    [disabled]="beneficiarioEscogido === undefined"
    [style.opacity]="beneficiarioEscogido === undefined ? '0.5' : '1'"
    [style.cursor]="beneficiarioEscogido === undefined ? 'not-allowed' : 'pointer'"
    style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
    Continuar
  </button>

  <button type="button" (click)="goToBack()"
    style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 12px; margin-top: 10px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: background 0.2s;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
    Volver
  </button>
</div>
